<template>
  <section>
    <Card id="imports-details" />
  </section>
</template>

<script>
import Card from '@/components/Imports/Details/Card.vue';

export default {
  components: {
    Card
  },
  mounted() {
    this.$store.dispatch('setBreadcumbs', this.breadcumbs);
  },
  computed: {
    breadcumbs() {
      return ['schedule.pharmacyInboundManifest'];
    }
  }
};
</script>
